import React from 'react';

const cardBase =
  'w-full flex items-center justify-center rounded-xl gap-3.5 mx-auto bg-gradient-to-br from-[#fcb319] to-[#f5a500] shadow-[0_4px_16px_rgba(252,179,25,0.25)] p-3.5 px-[18px] max-md:p-4 max-md:px-5 max-md:gap-4';

const cardVariants = {
  full: '',
  skill: 'flex-row p-4 px-5 max-md:p-4 max-md:px-[18px]',
};

const iconBase =
  'w-10 h-10 rounded-[10px] flex items-center justify-center flex-shrink-0 backdrop-blur-[10px] shadow-[0_2px_8px_rgba(29,71,70,0.2)] max-md:w-11 max-md:h-11 max-md:rounded-xl [&_svg]:w-7 [&_svg]:h-7 max-md:[&_svg]:w-[22px] max-md:[&_svg]:h-[22px]';

const iconVariants = {
  full: 'bg-white/25 [&_svg]:fill-[#1d4746]',
  skill:
    'bg-[rgba(29,71,70,0.2)] text-[#1d4746] dark:bg-[rgba(29,71,70,0.35)] dark:text-[#1d4746] [&_svg]:fill-current',
  drill:
    'bg-[rgba(30,61,111,0.2)] text-[#1e3d6f] [&_svg]:fill-current',
};

const contentBase = 'flex flex-col gap-1.5 flex-1';

const labelBase =
  'text-xs font-semibold uppercase tracking-[0.8px] text-[var(--text-primary)] dark:text-[#1d4746] max-md:text-[11px] max-md:tracking-[0.6px]';

const labelVariants = {
  full: '',
  skill: 'text-[11px] tracking-[1.5px] text-[rgba(29,71,70,0.85)]',
  drill: 'text-[11px] tracking-[1.5px] text-[rgba(30,61,111,0.85)]',
};

const valueBase = 'text-4xl font-bold leading-none text-[var(--text-primary)] dark:text-[#1d4746] max-md:text-4xl';

const valueVariants = {
  full: '',
  skill: 'text-[40px] font-extrabold tracking-[-1px] text-[#1d4746] max-md:text-4xl',
  drill: 'text-[40px] font-extrabold tracking-[-1px] text-[#1e3d6f] max-md:text-4xl',
};

const detailsBase =
  'flex gap-4 mt-1 text-[13px] font-medium text-[rgba(29,71,70,0.8)] dark:text-[rgba(29,71,70,0.9)] max-md:text-xs max-md:gap-3';

const detailsVariants = {
  full: '',
  skill: 'text-[rgba(29,71,70,0.8)]',
  drill: 'text-[rgba(30,61,111,0.8)]',
};

const detailItemBase = 'flex items-center gap-1';

/**
 * @param {'full' | 'skill'} variant - full: icon + score + details; skill: score only (centered)
 */
export function ScoreCard({ score, totalQuestions, correctCount, variant = 'full', isDrillVocab = false }) {
  const isSkill = variant === 'skill';
  const v = isSkill ? (isDrillVocab ? 'drill' : 'skill') : 'full';

  const StarIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={v === 'full' ? '#1d4746' : 'currentColor'}
      />
    </svg>
  );

  return (
    <div className={`${cardBase} ${cardVariants[variant] || cardVariants.full}`}>
      <div className={`${iconBase} ${iconVariants[v]}`}>
        <StarIcon />
      </div>
      <div className={contentBase}>
        <div className={`${labelBase} ${labelVariants[v]}`}>SCORE</div>
        <div className={`${valueBase} ${valueVariants[v]}`}>{score}</div>
        {(totalQuestions != null || correctCount != null) && (
          <div className={`${detailsBase} ${detailsVariants[v]}`}>
            <span className={detailItemBase}>
              {correctCount ?? '-'}/{totalQuestions}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
